const d = {
  darkest: "#000",
  lightest: "#fff",
  primary: "#412BC7",
  "primary-light": "#6B5BD9",
  // lightened primary by 15%
  "primary-dark": "#2D1F8F",
  // darkened primary by 25%
  secondary: "#BCD9D8",
  "secondary-light": "#D8E8E7",
  // lightened secondary by 10%
  "secondary-dark": "#6E8C8B",
  // darkened secondary by 25%
  // Shades of gray, from light (100) to heavy (dark) (900)
  // In order to maintai contrast and consistency, it is reccomended to stick to 9 grayscales in your pallette.
  // If a colour in the design doesn't match one of these shades, try and replace it with its nearest neighbour instead of adding new shades.
  gray: {
    100: "#f2f2f2",
    200: "#dfdfdf",
    300: "#cdcdcd",
    400: "#bababa",
    500: "#707070",
    600: "#5a5a5a",
    700: "#454545",
    800: "#313131",
    900: "#101010"
  },
  // These are essentially state colours used for notifications and the like.
  highlight: {
    success: "#1EAC70",
    info: "lightblue",
    warning: "orange",
    error: "#DF3755"
  }
}, u = {
  // Defines the base length of transitions
  // Usage ex. `transition: height var(--transition-timing-slow) 0ms var(--transition-timingFunction-in-out)`
  timing: {
    slow: "1s",
    medium: "500ms",
    fast: "150ms"
  },
  // Defines easing in/out timings using a custom cubic-bezier.
  timingFunction: {
    in: "cubic-bezier(0.4, 0, 1, 1)",
    out: "cubic-bezier(0, 0, 0.2, 1)",
    "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
  },
  // Wraps the transitions in easy-to-use combinations
  // Usage ex. `transition: color var(--transition-quick)`
  fast: "var(--transition-timing-fast) 0ms var(--transition-timingFunction-in)",
  medium: "var(--transition-timing-medium) 0ms var(--transition-timingFunction-in)",
  slow: "var(--transition-timing-slow) 0ms var(--transition-timingFunction-in)"
}, p = {
  "2xs": ".3125rem",
  xs: ".625rem",
  sm: ".75rem",
  md: "1rem",
  lg: "1.3125rem",
  xl: "2rem",
  "2xl": "3rem"
}, f = {
  // The side-gap specified the spacing between the browser window and the application layout
  "side-gap": {
    sm: "var(--grid-gap-sm)",
    md: "var(--grid-gap-md)",
    lg: "var(--grid-gap-lg)"
  },
  // The grid gap specifies the spacing between areas in your grid layout
  gap: {
    sm: "var(--spacing-md)",
    md: "var(--spacing-lg)",
    lg: "var(--spacing-xl)"
  },
  // The maxWidth specifies the maximum widths of the layout components
  maxWidth: {
    page: "90rem",
    content: "40rem"
  }
}, x = {
  sm: "0.125rem",
  md: "0.25rem",
  lg: "0.5rem",
  xl: "0.75rem",
  full: "9999px"
}, b = {
  light: "0px 0px 8px rgba(0, 0, 0, 0.06)",
  base: "0px 0px 6px rgba(0, 0, 0, 0.16)",
  medium: "0px 0px 11px rgba(0, 0, 0, 0.20)",
  heavy: "0px 0px 16px rgba(0, 0, 0, 0.24);",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.5)",
  inset: "inset 1px 1px 4px rgba(0, 0, 0, 0.12)"
}, y = {
  family: {
    primary: [
      "system-ui",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      '"Noto Sans"',
      "sans-serif"
    ],
    secondary: ["Menlo", "Monaco", "Consolas", '"Liberation Mono"', '"Courier New"', "monospace"]
  },
  size: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.25rem",
    xl: "1.5rem",
    "2xl": "2rem",
    "3xl": "2.5rem",
    "4xl": "3rem",
    "5xl": "4rem",
    "6xl": "5rem"
  },
  // Most webfonts don't have all these variants, but most system fonts do.
  weight: {
    primary: {
      hairline: "100",
      thin: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    },
    secondary: {
      hairline: "100",
      thin: "200",
      light: "300",
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700",
      extrabold: "800",
      black: "900"
    }
  }
}, h = {
  xs: ".9",
  sm: "1",
  md: "1.3",
  lg: "1.6",
  xl: "2"
}, w = {
  color: d,
  transition: u,
  spacing: p,
  grid: f,
  borderRadius: x,
  boxShadow: b,
  font: y,
  lineHeight: h
};
function $(r, e = null, i = null) {
  const o = Object.keys(r), s = i === !0 || typeof i == "string";
  return i === !0 && (i = ""), o.length && o.forEach((a) => {
    const n = r[a];
    let t = a;
    if (n)
      if (e && (t = `${e}-${a}`), Array.isArray(n)) {
        const m = n.join(", ");
        s ? i = `${i}${l(t, m)}` : c(t, m);
      } else
        typeof n == "object" ? i = $(n, t, i) : s ? i = `${i}${l(t, n)}` : c(t, n);
  }), i;
}
function l(r, e) {
  if (typeof r != "string") {
    console.error(`${r} is not a string`);
    return;
  }
  if (e || typeof e == "string" && e.length)
    return `--${g(r)}:${e};`;
}
function c(r, e) {
  if (!(typeof document > "u")) {
    if (typeof r != "string") {
      console.error(`${r} is not a string`);
      return;
    }
    e && e.length && document.documentElement.style.setProperty(`--${g(r)}`, e);
  }
}
function g(r) {
  const e = "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;", i = "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------", o = new RegExp(e.split("").join("|"), "g");
  return r.toString().replace(/\s+/g, "-").replace(o, (s) => i.charAt(e.indexOf(s))).replace(/&/g, "-and-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
}
export {
  w as defaultTheme,
  c as setCssProperty,
  $ as setVariablesFromConfigObject,
  l as stringifyCssProperty
};
